import {getCurrentLayout} from "../../appLayout";
import store from "../../../store";
import config from "../components/canvas/store/sqftConfig";
//import ManualCalculate from "../components/canvas/core/controls/manualCalculate";
import workspace from "../components/canvas/core/workspace";
import history from "../components/canvas/core/workspaceHistory";
import {
  enableSquareFootage,
  setSQFTViewMode,
  setSquareFootageGroup,
  updateSQFTCalculations
} from "../../../actions/sqftFunctions";
import {toggleSelectionFeatureInfo} from "../../../actions/actionFunctions";
import {manualCalculateImport} from "./sqftDataMapper";
import {getInitialManualCalcRows} from "../../../reducers/sqft/sqftManualCalculationReducer";
import {updateManualCalculateRows} from "../../../actions/sqftManualCalculationFunctions";
import {hashHistory} from "react-router";
import {
  getAvailableSteps, getCorrectedWizardGroupForFeature,
  navItemIsExcluded
} from "../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import {isSameVisualizerWizard} from "../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions2";
import {getNextNotCheckedStep} from "../../qkbPages/materialsWizard/useChangeWizardStepRoute";
import {setMeasureUnit} from "./sqftConfigHelper";
import {CABINETS_TO_HANDLE, SQFT_VIEW_MODE} from "../constants";

const getStoredWizardSelectedValues = (allWizardsValues, wizardItemId, activeQuoteIndex) => {
  return allWizardsValues.find(wizObject => {
    return wizObject.wizardItemId === wizardItemId && wizObject.quoteIndex === activeQuoteIndex;
  })?.wizardSelectedValues || {};
};

export const getWizardContexts = (state, wizardItem = null, useAllWizards = false) => {
  const {wizardSelectedValues, wizardActiveItem, wizardList, allWizardsValues} = state.wizardState;
  const {activeQuoteIndex} = state.quotesState;

  if (wizardItem) {
    return [{
      wizardItem,
      wizardSelectedValues: wizardItem.id === wizardActiveItem?.id
        ? wizardSelectedValues
        : getStoredWizardSelectedValues(allWizardsValues, wizardItem.id, activeQuoteIndex),
    }];
  }

  if (!useAllWizards) {
    return wizardActiveItem ? [{wizardItem: wizardActiveItem, wizardSelectedValues}] : [];
  }

  return wizardList
    .filter(wizItem => isSameVisualizerWizard(wizItem))
    .map(wizItem => ({
      wizardItem: wizItem,
      wizardSelectedValues: wizItem.id === wizardActiveItem?.id
        ? wizardSelectedValues
        : getStoredWizardSelectedValues(allWizardsValues, wizItem.id, activeQuoteIndex),
    }));
};

export const getFeatureGroup = (mainNeeded = "center_island_countertop") => {
  const layout = getCurrentLayout();
  let featureGroup = layout.getSubPartFromQtCategories(mainNeeded);
  if (!featureGroup) {
    const foundGroup = layout.getFeatureGroupByPartId(mainNeeded);
    if (foundGroup) {
      featureGroup = {part: foundGroup}
    }
  }
  if (!featureGroup) {
    featureGroup = layout.parts["Countertop"] && layout.parts["Countertop"].countertop
      ? {part: layout.parts["Countertop"].countertop}
      : null;
  }

  return featureGroup
}

export const getHandleFeatureGroupFromShape = (shape) => {
  const layout = getCurrentLayout();
  const handlesPartId = CABINETS_TO_HANDLE[shape.partId];

  return layout.getFeatureGroupByPartId(handlesPartId);
}

/**
 * Returns nav items for a feature group.
 * In wizard mode can read only active wizard or all wizardList items.
 *
 * @param {Object} featureGroup
 * @param {string} searchText
 * @param {Object} filters
 * @param {boolean} withPlaceholders
 * @param {boolean|string} withQuotingToolFeatures
 * @param {boolean} useAllWizards
 * @returns {Array}
 */
export const getNavItems = (
  featureGroup,
  searchText = "",
  filters= {},
  withPlaceholders = true,
  withQuotingToolFeatures = false,
  useAllWizards = false,
  includeHidePriceNoCart = false
) => {
  let navItems = [];
  if (!featureGroup) {
    return navItems
  }
  let checkFeatureGroup = featureGroup.part ? featureGroup : {part: featureGroup}
  const state = store.getState();
  const {wizardIsActive} = state.wizardState;

  if (wizardIsActive) {
    navItems = getNavItemsFromTheWizard(
      checkFeatureGroup,
      searchText,
      filters,
      null,
      document.kvConfig.visualizerType,
      null,
      useAllWizards,
      includeHidePriceNoCart
    );
  } else {
    const layout = getCurrentLayout();
    navItems = layout.designNavigationItems(checkFeatureGroup,
      filters,
      searchText,
      withPlaceholders,
      withQuotingToolFeatures,
      [],
      { firstFeature: null, firstConditions: null },
    )
  }

  return navItems;
}

export const onSQFTLoadPrepareData = () => {
  const layout = getCurrentLayout();
  const state = store.getState();
  const quotes = state.quotesState.quotes;
  const activeQuoteIndex = state.quotesState.activeQuoteIndex;
  const filterGroups = state.filterState.filterGroups;
  const fabricatorData = state.fabricatorState;

  //if (this.iframeElement && this.iframeElement.contentWindow) {
  const activeQuote = quotes[activeQuoteIndex];
  //const {intl, fabricatorData} = this.props;
  const measureUnit = fabricatorData.settings.measureUnit;
  const payload = {
    loadData: (activeQuote && activeQuote.sqFtCalcData) ? activeQuote.sqFtCalcData : null,
    measureUnit,
    fabricatorId: document.kvConfig.userId,
    fabricatorData,
    currentLayout: layout.getCurrentLayoutAbbreviation(),
    filterGroups: filterGroups,
    //language: intl.locale
  }
  // if (hardCodeIsLowes()) {
  //   let translates = {}
  //   Object.keys(intl.messages).forEach(messageKey => {
  //     if (messageKey.startsWith("transDoc.")) {
  //       if (!translates[intl.locale]) {
  //         translates[intl.locale] = {};
  //       }
  //       translates[intl.locale][messageKey] = intl.messages[messageKey]
  //     }
  //   })
  //   payload.translates = translates;
  // }
  console.log("sqft postMessage initial load data:", payload);

  return payload;
  //}
};

//todo is this all needed?
export const onSQFTLoadImport = (payload) => {
  let {fabricatorId, fabricatorData, currentLayout, measureUnit, loadData, filterGroups} = payload;
  config.fabricatorData = fabricatorData;
  window.fabricatorId = fabricatorId;
  window.currentLayout = currentLayout;
  config.filterGroups = filterGroups;
  //TranslatesProvider.replaceHtml(language, translates);
  // config.fabricatorData = fabricatorData; // set if needed

  //todo
  //toolbar.setFabricatorButtons(fabricatorData); // specific fabricator rules
  if (measureUnit) {
    [].slice.call(document.querySelectorAll(".settings-units [data-value]")).forEach(element => {
      (element.dataset.value === measureUnit)
        ? element.classList.add("active")
        : element.classList.remove("active")
    });
    setMeasureUnit(measureUnit);
    history.rememberConfig({measureUnit});
    //todo
    //ManualCalculate.onMeasureUnitChange();
  }
  if (loadData) {
    loadData = (typeof loadData === 'string') ? JSON.parse(loadData) : loadData;
    if (loadData.manualCalculate === true) {
      manualCalculateImport(loadData);
    } else {
      workspace.import(loadData);
    }
  } else if (!config.tutorialIsRunning) {
    workspace.import({}); // if new room is opened - clear the previous(but not the first time if tutorial is active)
    store.dispatch(updateManualCalculateRows(getInitialManualCalcRows()));
    //todo
    //ManualCalculate.import({})
  } else {
    store.dispatch(updateManualCalculateRows(getInitialManualCalcRows()));
  }
  const state = store.getState();
  const updateCalculations = state.sqftState.updateCalculations;
  store.dispatch(updateSQFTCalculations(updateCalculations + 1));
}

export const closeSQFTTool = (redirectToPage, shouldChangeWizardToNextStep, changeWizardStepRoute) => {
  const isSQFTinUrl = window.location.hash.includes("sqft");
  store.dispatch(setSQFTViewMode(SQFT_VIEW_MODE.twoDMode));

  if (isSQFTinUrl) {
    hashHistory.push(redirectToPage);
    if (shouldChangeWizardToNextStep) {
      changeWizardToNextStep(changeWizardStepRoute)
    }
  } else {
    store.dispatch(enableSquareFootage(false));
    store.dispatch(setSquareFootageGroup(null));
    if (shouldChangeWizardToNextStep) {
      changeWizardToNextStep(changeWizardStepRoute)
    }
  }
}

export const changeWizardToNextStep = (changeWizardStepRoute) => {
  const state = store.getState();
  const {wizardIsActive, wizardActiveItem} = state.wizardState;
  const {selectionFeatureInfo} = state.selectionState;
  if (wizardIsActive && wizardActiveItem) {
    if (selectionFeatureInfo) {
      store.dispatch(toggleSelectionFeatureInfo(null));
    }
    const realNextStep = getNextNotCheckedStep(false, false);
    changeWizardStepRoute(realNextStep);
  }
}

const getUpdatedNavItemWithWizardProps = (navItem, wizardGroup, newWizardStep, wizardItemId = null) => {
  const newWizardGroup = getCorrectedWizardGroupForFeature(wizardGroup, navItem.part);
  return {
    ...navItem,
    fromWizardId: wizardItemId,
    fromWizardGroupId: newWizardGroup.id, // this is saved in sqft data
    newWizardGroup, // this is passed to dropdown to select wizard values
    newWizardStep,
  }
}

/**
 * Returns wizard-filtered nav items for a subPart.
 *
 * If `useAllWizards` is true, merges matching steps from all items in `wizardList`.
 *
 * @param {Object} subPart
 * @param {string} searchText
 * @param {Object} filters
 * @param {string|number|null} wizardGroupId
 * @param {string} visualizerType
 * @param {Object|null} parentsList
 * @param {boolean} useAllWizards
 * @returns {Array}
 */
export const getNavItemsFromTheWizard = (
  subPart,
  searchText = "",
  filters= {},
  wizardGroupId = null,
  visualizerType = document.kvConfig.visualizerType,
  parentsList,
  useAllWizards = false,
  includeHidePriceNoCart = false
) => {
  const shouldDecorateWizardProps = (wizardStep) => {
    return !wizardGroupId || wizardStep.stepGroups[0]?.mergedGroups?.length > 1 || useAllWizards;
  };

  let groupName = subPart.part.wasCreatedFromGroupName || subPart.part.dbName || subPart.part.partName; //assign same stems as for the parent featureGroup (for the slabs)
  const wizardSteps = getWizardGroupsFromTheWizard(
    groupName,
    wizardGroupId,
    false,
    parentsList,
    null,
    useAllWizards,
    includeHidePriceNoCart
  );
  const layout = getCurrentLayout(visualizerType);
  const navItems = layout.designNavigationItems(subPart, filters, searchText, false, "all");

  // console.log("wizardSteps", wizardSteps);
  let allNavItems = [];
  if (wizardSteps.length) {
    if (wizardSteps.length === 1) {
      const navItemsFromWizardGroup = navItems.filter(navItem => !navItemIsExcluded(navItem, wizardSteps[0].stepGroups[0]))
      if (navItemsFromWizardGroup.length) {
        allNavItems = navItemsFromWizardGroup
        if (shouldDecorateWizardProps(wizardSteps[0])) {
          allNavItems = allNavItems.map(navItem => {
            return getUpdatedNavItemWithWizardProps(
              navItem,
              wizardSteps[0].stepGroups[0],
              wizardSteps[0].stepIndex,
              wizardSteps[0].wizardItemId
            )
          })
        }
      }
    } else {
      for (const wizardStep of wizardSteps) {
        const navItemsFromWizardGroup = navItems.filter(navItem => !navItemIsExcluded(navItem, wizardStep.stepGroups[0]));
        if (navItemsFromWizardGroup.length) {
          if (!allNavItems.length) {
            allNavItems = navItemsFromWizardGroup;
            if (shouldDecorateWizardProps(wizardStep)) {
              allNavItems = allNavItems.map(navItem => {
                return getUpdatedNavItemWithWizardProps(
                  navItem,
                  wizardStep.stepGroups[0],
                  wizardStep.stepIndex,
                  wizardStep.wizardItemId
                )
              })
            }
          } else {
            navItemsFromWizardGroup.forEach(newNavItem => {
              if (!allNavItems.some(navItem => navItem.part.dbFeature.id === newNavItem.part.dbFeature.id)) {
                allNavItems.push(shouldDecorateWizardProps(wizardStep)
                  ? getUpdatedNavItemWithWizardProps(
                    newNavItem,
                    wizardStep.stepGroups[0],
                    wizardStep.stepIndex,
                    wizardStep.wizardItemId
                  )
                  : newNavItem)
              }
            })
          }
        }
      }
    }
  }

  return allNavItems
}

/**
 * returns all wizardGroups with current groupName and wizard group id if provided
 * @param groupName {string}
 * @param wizardGroupId {string|number|null}
 * @param forFeature {featureInterface}
 * @param parentsList {object}
 * @param wizardItem {wizardItemInterface}
 * @param useAllWizards {boolean}
 * @returns {array}
 */
export const getWizardGroupsFromTheWizard = (
  groupName,
  wizardGroupId = null,
  forFeature = null,
  parentsList = null,
  wizardItem = null,
  useAllWizards = false,
  includeHidePriceNoCart = false
) => {
  const state = store.getState();
  const {isRenuit} = state.fabricatorState;
  const wizardContexts = getWizardContexts(state, wizardItem, useAllWizards);

  let wizardSteps = wizardContexts.reduce((total, wizardContext) => {
    const currentWizardSteps = getAvailableSteps(
      wizardContext.wizardItem,
      wizardContext.wizardSelectedValues,
      true
    ).map(wizardStep => ({
      ...wizardStep,
      wizardItemId: wizardContext.wizardItem.id,
      wizardItem: wizardContext.wizardItem,
    }));

    if (isRenuit && groupName === "Bottom Cabinet" && !wizardGroupId && parentsList && parentsList.top_cabinet
      && parentsList.top_cabinet.features && parentsList.top_cabinet.features[0]
      && parentsList.top_cabinet.features[0].feature && parentsList.bottom_cabinet && parentsList.bottom_cabinet.subPart
      && parentsList.bottom_cabinet.subPart.part) {
      const layout = getCurrentLayout();
      const sameBottomCabinetFeature = layout.getFeatureBySku(parentsList.top_cabinet.features[0].feature.dbFeature.sharedFeatureName, "bottom_cabinet", false, true);
      if (sameBottomCabinetFeature) {
        const wizGroup = wizardContext.wizardItem?.wizardGroups.find(wizGroup => {
          return wizGroup.groupName === "Bottom Cabinet" && wizGroup.featuresIncluded && wizGroup.featuresIncluded.length > 1
            && !navItemIsExcluded({part: sameBottomCabinetFeature}, wizGroup)
        });
        if (wizGroup) {
          currentWizardSteps.push({
            stepGroups: [wizGroup],
            stepIndex: 6,
            wizardItemId: wizardContext.wizardItem.id,
            wizardItem: wizardContext.wizardItem,
          });
        }
      }
    }

    return [...total, ...currentWizardSteps];
  }, []);

  if (useAllWizards) {
    wizardSteps = wizardSteps.sort((a, b) => {
      if (a.stepIndex !== b.stepIndex) {
        return a.stepIndex - b.stepIndex;
      }
      return (a.wizardItemId || 0) - (b.wizardItemId || 0);
    });
  }

  return wizardSteps.filter((wizardStep) => {
    if (wizardStep.stepGroups.length !== 1 || (wizardStep.stepGroups[0].groupName !== groupName)) {
      return false
    }
    if (wizardGroupId && (wizardStep.stepGroups[0].id !== wizardGroupId)) {
      return false
    }
    if (!includeHidePriceNoCart && wizardStep.stepGroups[0].hidePriceNoCart) { // we can't add cart items from this group! renuit issue
      return false
    }
    if (forFeature) {
      return !navItemIsExcluded({part: forFeature}, wizardStep.stepGroups[0])
    }
    return true
  });
}

export const getUnderlaymentFeature = () => {
  const underlaymentFeatureGroup = getFeatureGroup('underlayment');
  const state = store.getState();
  const {wizardIsActive} = state.wizardState;
  let navItems;
  if (wizardIsActive) {
    navItems = getNavItemsFromTheWizard(underlaymentFeatureGroup, "", {});
  } else {
    const layout = getCurrentLayout();
    navItems = layout.designNavigationItems(underlaymentFeatureGroup,
      {},
      "",
      false,
      "all",
      [],
      { firstFeature: null, firstConditions: null },
    )
  }

  const underlaymentFeaureName = 'Xtone Underlayment';
  const underlaymentFeaure = navItems.find(navItem => navItem.part.getFeatureName() === underlaymentFeaureName);
  if (underlaymentFeaure) {
    return underlaymentFeaure
  }

  return navItems.length ? navItems[0] : null
}
